import axios from 'axios'
import wiki from 'wikijs'
import { format } from '../../../../services/format'
import { pageImage, pointsToConcav } from './utils'

const defaultLang = 'fr'

const schemaPoi = {
  db: () => 'poi', // required for bulk save docs in indexed db
  title: 'title',
  coords: p => [p.coordinates[0].lon, p.coordinates[0].lat],
  thumb: p => p.thumbnail ? p.thumbnail.source : null,
  image: p => pageImage(p),
  wiki: 'pageid'
}

export const getAreaPois = (aLonLat, lang = defaultLang) => {
  const url = `https://${lang}.wikipedia.org/w/api.php?origin=*&action=query&generator=geosearch&prop=coordinates|pageimages&ggscoord=${aLonLat[1]}|${aLonLat[0]}&format=json&pithumbsize=200`
  return new Promise((resolve, reject) => {
    axios.get(url).then(res => {
      const pages = res.data.query ? res.data.query.pages : {}
      const pois = Object.keys(pages).map(id => {
        const p = pages[id]
        return Object.assign({ _id: lang + '-' + p.pageid }, format(schemaPoi, p))
      })
      const area = pois.length > 1 ? pointsToConcav(pois.map(p => p.coords)) : null
      resolve({ area, pois })
    }).catch(err => reject(err))
  })
}

export const getPoiContent = (pageId, lang = defaultLang) => {
  const apiUrl = `https://${lang}.wikipedia.org/w/api.php`
  return wiki({ apiUrl }).findById(pageId)
}
